import { MediaPlacementType } from '../enums/media-placement';

export class MediaFilter {
  title?: string;
  cityId?: number;
  mediaTypeId?: number;
  regionId?: number;
  countryId?: number;
  withPrices?: boolean;
  hasChildren?: boolean;
  hasParent?: boolean;
  placement?: MediaPlacementType;
  companyId?: number;
}
